import { render } from "./buy-now.vue?vue&type=template&id=77d62e22"
import script from "./buy-now.vue?vue&type=script&lang=js"
export * from "./buy-now.vue?vue&type=script&lang=js"

import "./buy-now.vue?vue&type=style&index=0&id=77d62e22&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__